import { render, staticRenderFns } from "./Spisi.vue?vue&type=template&id=1260c748&"
import script from "./Spisi.vue?vue&type=script&lang=js&"
export * from "./Spisi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports